import { NotificacaoService } from './../../../service/notificacao/notificacao.service';
import { Component, OnInit } from '@angular/core';
import NotificacaoModel from 'app/model/notificacao/notificacao.model';
import { error } from 'console';

@Component({
  selector: 'app-notificacao',
  templateUrl: './notificacao.component.html',
  styleUrls: ['./notificacao.component.scss']
})
export class NotificacaoComponent implements OnInit {
  count: number = 0;
  notificacoes: NotificacaoModel[] = [];
  lida = false;

  constructor(private notificacaoService: NotificacaoService) { }

  ngOnInit() {
    this.buscarNotificacoes();
  }

  buscarNotificacoes() {
    this.notificacaoService.buscarNotificacoes().subscribe(data => {
      if (data.result != null) {
        this.notificacoes = data.result;
      }
    }, err => {
      console.error(err);
    });
  }

  buscarNotificacoesNaoLidas() {
    this.notificacaoService.buscarNotificacoesNaoLidas().subscribe(data => {
      if (data.result != null) {
        this.count = data.result.length;
        this.notificacaoService.updateCount(this.count);
      }
    }, err => {
      console.error(err);
    });
  }

  marcarComoLido(notificacao: NotificacaoModel) {
    this.notificacaoService.marcarComoLido(notificacao.id).subscribe(data => {
      this.notificacoes.forEach(notify => {
        if (notify.id === notificacao.id) {
          notify.lida = true;
        }
      });
      this.buscarNotificacoesNaoLidas();
    }, err => {
      console.error(err);
    });
  }

  marcarComoNaoLida(notificacao: NotificacaoModel) {
    this.notificacaoService.marcarComoNaoLido(notificacao.id).subscribe(data => {
      this.notificacoes.forEach(notify => {
        if (notify.id === notificacao.id) {
          notify.lida = false;
        }
      });
      this.buscarNotificacoesNaoLidas();
    }, err => {
      console.error(err);
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/notificacao/notificacao/notificacao.component.ts